import request from '@/config/axios'
import { asCapacityPage, type CapacityPageResult } from '@/api/capacity/page'

export interface PlatformRiderItem {
  phone?: string
  city?: string
  mode?: string
  orgId?: string
  online?: boolean
  authenticated?: boolean
  certStatus?: string
  protocolAgreed?: boolean
  canGoOnline?: boolean
  realName?: string
  idNumber?: string
  idFrontUrl?: string
  idBackUrl?: string
  healthCertUrl?: string
  healthCertExpire?: string
  rejectReason?: string
  success?: boolean
  message?: string
}

export interface ActResult {
  success?: boolean
  message?: string
}

export const listPlatformRiders = async (params?: {
  city?: string
  mode?: string
  online?: boolean
  certStatus?: string
  pageNo?: number
  pageSize?: number
}): Promise<CapacityPageResult<PlatformRiderItem>> => {
  const raw = await request.get({ url: '/capacity/platform/rider/list', params })
  return asCapacityPage<PlatformRiderItem>(raw, params?.pageNo, params?.pageSize)
}

export const getPlatformRider = (phone: string) => {
  return request.get<PlatformRiderItem>({ url: '/capacity/platform/rider/get', params: { phone } })
}

export const forceOfflineRider = (phone: string) => {
  return request.post<ActResult>({
    url: '/capacity/platform/rider/force-offline',
    params: { phone },
  })
}
